
import { Options, Vue } from 'vue-class-component';
import BusquedaConFiltros from '@/components/BusquedaConFiltros.vue';
import ListadoAsignaciones from '@/components/asignaciones/ListadoAsignaciones.vue';
import FiltrosAsignaciones from '@/components/asignaciones/FiltrosAsignaciones.vue';
import FiltroAsignaciones from '@/model/filtros/FiltroAsignaciones';
import { Prop } from 'vue-property-decorator';
import { getReport, searchData } from '@/api/AsignacionesApi';
import { notifyError } from '@/utils/NotifyUtils';
import Asignacion from '@/model/Asignacion';
import { mapToPageablePayload } from '@/utils/ApiUtils';

@Options({
  components: { BusquedaConFiltros, ListadoAsignaciones, FiltrosAsignaciones },
  name: 'BusquedaAsignaciones',
})
export default class BusquedaAsignaciones extends Vue {
  @Prop({ type: String, default: 'Búsqueda' })
  titulo!: string;

  @Prop({ default: false, type: Boolean })
  loadingListado = false;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  loading = false;

  dialog = false;

  page: any = {};

  private id = 0;

  showListado = true;

  filtro: FiltroAsignaciones = this.createNewInstance();
  FiltroAsignacionesForm(): Vue & {
    validate: () => boolean;
    resetValidation(): void;
  } {
    return this.$refs.filtroComponent as Vue & {
      validate: () => boolean;
      resetValidation(): void;
    };
  }

  createNewInstance(): FiltroAsignaciones {
    return new FiltroAsignaciones();
  }

  private localVal = undefined as unknown as any;

  async buscar(val?: any) {
    this.loading = true;
    if (val?.rowsPerPage) {
      this.localVal = val;
    } else if (this.localVal) {
      val = this.localVal;
    }
    const page = val && val.page ? val.page : 1;

    const size = val && val.rowsPerPage ? val.rowsPerPage : 15;

    try {
      if (await this.FiltroAsignacionesForm().validate()) {
        this.page = mapToPageablePayload<Asignacion>(
          await searchData(`?page=${page - 1}&size=${size}${this.filtro.toQuerystring()}`)
        );
      }
    } catch (err) {
      notifyError(err);
    } finally {
      this.loading = false;
    }
  }

  async descargar() {
    try {
      this.loading = true;
      if (await this.FiltroAsignacionesForm().validate()) {
        await getReport(this.filtro);
      }
    } catch (err) {
      notifyError(err.message ? err.message : err);
    } finally {
      this.loading = false;
    }
  }

  limpiar() {
    this.page = {};
    this.localVal = {};
    this.filtro = new FiltroAsignaciones();
    this.$nextTick(() => this.FiltroAsignacionesForm().resetValidation());
    this.showListado = true;
  }
}
